import type { CSSProperties } from 'react';
import { cx } from '../../lib/cx.ts';
import './States.css';

export interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  radius?: number | string;
  circle?: boolean;
  className?: string;
  style?: CSSProperties;
}

/** Shimmer placeholder (1.4s). Give it the same geometry as the real content. */
export function Skeleton({ width = '100%', height = 14, radius, circle = false, className, style }: SkeletonProps) {
  return (
    <span
      aria-hidden="true"
      className={cx('skeleton', className)}
      style={{ width, height, borderRadius: circle ? '50%' : radius, ...style }}
    />
  );
}

export function SkeletonText({ lines = 3, className }: { lines?: number; className?: string }) {
  return (
    <span className={cx('skeleton-text', className)} aria-hidden="true">
      {Array.from({ length: lines }, (_, i) => (
        <Skeleton key={i} width={i === lines - 1 ? '62%' : '100%'} height={12} />
      ))}
    </span>
  );
}
